// CSS is already placed in index.html
import { CDN_URL } from 'config/config'
import * as S from './SplashSpinner.styles'

const MT_SPINNER_URL = `${CDN_URL}/spinners/splash-mt.svg`

/** @public */
export function InlineSpinner() {
  return <S.SpinnerImage src={MT_SPINNER_URL} alt="Loading..." />
}

export default function SplashSpinner() {
  return (
    <>
      <img
        className="site-spinner"
        data-testid="splash-spinner"
        src={MT_SPINNER_URL}
        alt=""
        width="34"
        height="34"
      />
    </>
  )
}
